import axios from "axios";
import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Navigate } from "react-router-dom";
import { ExclamationIcon, XIcon } from "@heroicons/react/outline";
import { CheckCircleIcon } from "@heroicons/react/solid";
import { PaginationLinks } from "./helper";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { DataContext } from "./Context/DataContext";

let invoiceIdsV = [];

class InvoiceList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false,
      setSidebarOpen: false,
      showmsg: false,
      redirect: false,
      deleteRedirect: false,
      logoutRedirect: false,
      invoices: [],
      error_list: [],
      cryptKey: "",
      deletealartmsg: false,
      deletecustomer: false,
      deleteMessage: "Are you sure you want to delete the due ?",
      links: [],
      Minidash: [],
      houseList: [],
      selectedPerson: "",
      invoice_house_id: "",
      totalnoof: "",
      perpage: "",
      from: "",
      to: "",
      loader: "",
      query: "",
      overLay: "",
      masterChecked: false,
      fromdate: "",
      todate: "",
      fromdateas: "",
      todateas: "",
      page: 1,
      search: "",
      searchContent: "",
      make_paid: false,
      loader_status: false,
      try_again_status: false,
      main_content_status: false,
    };
  }
  setLoaderFunction = () => {

    this.setState({
      loader_status: true,
      try_again_status: false,
      main_content_status: false,
    });
  };
  closeLoaderFuncion = () => {
    this.setState({
      loader_status: false,
      try_again_status: false,
      main_content_status: true,
    });
  };

  enableTryAgain = () => {

    this.setState({
      loader_status: false,
      try_again_status: true,
      main_content_status: false,
    });
  };


  close = async (e) => {
    this.setState({ sidebarOpen: false });
  };
  open = async (e) => {
    this.setState({ sidebarOpen: true });
  };

  delete = async (e) => {
    this.setState({ deletealartmsg: true });
    this.setState({ cryptKey: e });
  };

  CheckPaymentStatus = async (e) => {
    this.setLoaderFunction();
    const token = localStorage.getItem("token");

   axios
      .get("api/check/payment/status/" + e, {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res) => {
        if (res.data.success) {
          toast.success('Payment Paid successfully');
          this.setLoaderFunction();
        } else {
          toast.error('Payment is Not Paid');
        }
        this.closeLoaderFuncion();
      });
  };


  haldleDelete = async (e) => {
    if (this.state.deletealartmsg) {
      this.setLoaderFunction(true, true);
      const token = localStorage.getItem("token");
      let id = this.state.cryptKey;
      const resDelete = axios
        .get("api/invoice/delete/" + id, {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((resDelete) => {
          if (resDelete.data.success) {
            this.setLoaderFunction(true, true);
            this.state.page = 1;
            this.paginationGeneral();
            this.setState({ deletealartmsg: false });
          } else {
            this.state.deleteMessage = resDelete.data.message;
            this.setState({
              deleteMessage: this.state.deleteMessage,
            });
          }

          this.closeLoaderFuncion();
        });
    }
  };

  makePaid = async () => {
    this.setLoaderFunction(true, true);

    const token = localStorage.getItem("token");
    let id = this.state.cryptKey;

    axios
      .post(
        "api/invoice/make/paid" + id,
        { invoice_ids: invoiceIdsV },
        {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        },
      )
      .then((res) => {
        if (res.data.success) {
          toast.success(res.data.message);
          this.setLoaderFunction(true, true);
          this.paginationGeneral();
        }
        this.closeLoaderFuncion();
      });
  };


  otherPaid = async () => {
    this.setLoaderFunction(true, true);

    const token = localStorage.getItem("token");
    let id = this.state.cryptKey;

    axios
      .post(
        "api/invoice/other/paid" + id,
        { invoice_ids: invoiceIdsV },
        {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        },
      )
      .then((res) => {
        if (res.data.success) {
          toast.success(res.data.message);
          this.setLoaderFunction(true, true);
          this.paginationGeneral();
        }
        this.closeLoaderFuncion();
      });
  };

  makeVacant = async () => {
    this.setLoaderFunction(true, true);

    const token = localStorage.getItem("token");
    let id = this.state.cryptKey;

    axios
      .post(
        "api/invoice/make/vacant" + id,
        { invoice_ids: invoiceIdsV },
        {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        },
      )
      .then((res) => {
        if (res.data.success) {
          toast.success(res.data.message);
          this.setLoaderFunction(true, true);
          this.paginationGeneral();
        }
        this.closeLoaderFuncion();
      });
  };

  UnpaidTenants = async () => {
    this.setLoaderFunction(true, true);

    const token = localStorage.getItem("token");
    let id = this.state.cryptKey;

    axios
      .post(
        "api/invoice/unpaid/tenants" + id,
        { invoice_ids: invoiceIdsV },
        {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        },
      )
      .then((res) => {
        if (res.data.success) {
          toast.success(res.data.message);
          this.setLoaderFunction(true, true);
          this.paginationGeneral();
        }
        this.closeLoaderFuncion();
      });
  };

  makeOverdue = async () => {
    this.setLoaderFunction(true, true);

    const token = localStorage.getItem("token");
    let id = this.state.cryptKey;

    axios
      .post(
        "api/invoice/make/overdue" + id,
        { invoice_ids: invoiceIdsV },
        {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        },
      )
      .then((res) => {
        if (res.data.success) {
          toast.success(res.data.message);
          this.setLoaderFunction(true, true);
          this.paginationGeneral();
        }
        this.closeLoaderFuncion();
      });
  };



  componentDidMount() {
    this.paginationGeneral();
  }


  async paginationGeneral() {
    try {
      this.setLoaderFunction()
      const token = localStorage.getItem("token");
      const { page, fromdateas, todateas, search } = this.state;
      
      const [
        { data: pagination },
      ] = await Promise.all([
        axios.get( `api/invoice/pagination?page=${page}&fromdate=${fromdateas}&todate=${todateas}&search=${search}`, { headers: { authorization: `Bearer ${token}`, Accept: "application/json" } })
      ]);
      const invoices = pagination.invoices.data;
      const updatedInvoiceData = invoices.map((invoice) => ({
        ...invoice,
        checkbox_status: false,
      }));

      let link = pagination.invoices.links;
      this.setState({ invoices: updatedInvoiceData });
      this.setState({ loader: "" });
      this.setState({ links: link });
      this.setState({ perpage: pagination.invoices.per_page });
      this.setState({ totalnoof:pagination.invoices.total });
      this.setState({ from: pagination.invoices.from });
      this.setState({ to: pagination.invoices.to });

      this.handleResetCheckBox();
      this.closeLoaderFuncion();

    } catch (error) {
      console.error("Error fetching data: ", error);
      this.enableTryAgain()
    }
  }



  tryAgain = () => {

    this.paginationGeneral()

  }


  Search = (e) => {
    this.state.search = e.target.value;
    this.state.page = 1;
    this.setLoaderFunction(true, false);
    this.paginationGeneral();
  };

  addinvoice = (e) => {
    this.setState({ redirect: true });
  };

  paginationFetch = async (e) => {
    if (e) {
      let url = new URL(e);
      let page = url.searchParams.get("page");
      this.state.page = page;
      this.setLoaderFunction(true, true);
      this.paginationGeneral();
    }
  };

  handlerFilter = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  logout = async (e) => {
    e.preventDefault();
    var token = localStorage.getItem("token");

    const res = await axios.get("api/logout", {
      headers: {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    if (res.data.success) {
      localStorage.removeItem("token");
      this.setState({ logoutRedirect: true }); 
    }
  };

  handleMasterChange = (e) => {
    this.setState(
      (prevState) => ({
        masterChecked: !prevState.masterChecked,
        invoices: prevState.invoices.map((invoice) => ({
          ...invoice,
          checkbox_status: !prevState.masterChecked,
        })),
      }),
      this.updateInvoiceIdsV,
    );
  };

  handleCheckboxChange = (index, invoiceId) => {
    this.state.invoices[index].checkbox_status =
      !this.state.invoices[index].checkbox_status;
    this.state.masterChecked = this.state.invoices.every(
      (invoice) => invoice.checkbox_status,
    );

    this.setState({
      invoices: this.state.invoices,
      masterChecked: this.state.masterChecked,
    });

    this.updateInvoiceIdsV();
  };

  updateInvoiceIdsV = () => {
    const { invoices } = this.state;

    const selectedInvoiceIds = invoices
      .filter((invoice) => invoice.checkbox_status)
      .map((invoice) => invoice.id);
    invoiceIdsV = selectedInvoiceIds;

    if (invoiceIdsV.length === 0) {
      this.setState({
        make_paid: false,
      });
    } else {
      this.setState({
        make_paid: true,
      });
    }
  };

  handleFilter = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleResetCheckBox = () => {
    this.setState({
      make_paid: false,
      masterChecked: false,
    });

    invoiceIdsV = [];
  };

  filterReset = (e) => {
    this.state.fromdate = "";
    this.state.todate = "";
    this.state.fromdateas = "";
    this.state.todateas = "";

    this.setState({ fromdate: this.state.fromdate, todate: this.state.todate });
    this.setLoaderFunction(true, true);
    this.paginationGeneral();
  };

  handleSearchSubmit = () => {
    this.state.fromdateas = this.state.fromdate;
    this.state.todateas = this.state.todate;
    this.state.page = 1;
    this.setLoaderFunction(true, true);
    this.paginationGeneral();
  };

  static contextType = DataContext;
  render() {
    let token = localStorage.getItem("token");

    const { searchContent } = this.context

    if (searchContent !== this.state.searchContent) {

        this.Search(searchContent)
        this.state.searchContent = searchContent

    }

    if (this.state.deleteRedirect) {
      //window.location.reload();
    } else {
    }
    if (token == null) {
      return <Navigate to={"/Login"} />;
    }
    if (this.state.logoutRedirect) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.redirect) {
      return <Navigate to={"/admin/invoice"} />;
    }

    return (
      <>
        <div>
          <div className={this.state.overLay} aria-hidden="true" />
          {this.state.loader_status && (
            <div className="h-screen flex items-center justify-center bg-white bg-opacity-50 z-50">
              <div className="bg-white p-4 rounded-md">
                <div className="flex items-center justify-center">
                  <div
                    className="animate-spin rounded-full border-4 border-l-blue-500 border-r-blue-500 border-t-blue-500 border-white-300 h-12 w-12"></div>
                </div>
                <p className="text-center mt-4">Loading...</p>
              </div>
            </div>
          )}
          {/*loader_status------------------------------------------------------------------------*/}

          {/*try_again_status-----------------------------------------------------------------------------*/}
          {this.state.try_again_status && (
            <div className="h-screen flex items-center justify-center bg-white ">
              <div className="flex flex-col items-center justify-center h-full">
                <p className="text-red-500">{this.state.error_customize}</p>
                <button
                  type="button"
                  onClick={this.tryAgain}
                  className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                  TryAgain
                </button>
              </div>
            </div>
          )}
          {/*try_again_status-----------------------------------------------------------------------------*/}

          {this.state.main_content_status && (

          <div className="flex flex-col flex-1">
            <main className="flex-1">
              <div className="py-6">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                  <div>
                    <dl className="mt-5 grid grid-cols-1 rounded-lg bg-white overflow-hidden shadow divide-y divide-gray-200 md:grid-cols-3 md:divide-y-0 md:divide-x">
                      {this.state.Minidash.map((item) => (
                        <div key={item.name} className="px-4 py-5 sm:p-6">
                          <dt className="text-base font-normal text-gray-900">
                            {item.name}
                          </dt>
                          <dd className="mt-1 flex justify-between items-baseline md:block lg:flex">
                            <div className="flex items-baseline text-2xl font-semibold text-indigo-600">
                              RS {item.stat}
                            </div>
                          </dd>
                        </div>
                      ))}
                    </dl>
                  </div>

                  {/* Replace with your content */}
                  <div className="px-4 sm:px-6 lg:px-8 mt-6">
                    <div className="sm:flex lg:flex">
                      <div className="sm:flex-auto">
                        <h1 className="text-xl font-semibold text-gray-900">
                          Dues List
                        </h1>
                        <p className="mt-2 text-sm text-gray-700">
                          A list of all the dues
                        </p>
                      </div>
                      <div className="flex flex-col lg:flex-row lg:items-center">
                        {this.state.make_paid && (
                     <div className="px-4 py-2 pt-5 flex">
                     <button
                         type="button"
                         onClick={this.makePaid}
                         className="ml-3 inline-flex justify-center rounded-md border border-transparent bg-green-600 py-1 px-3 text-sm font-medium text-white shadow-sm hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                     >
                         Make Paid
                     </button>
{/*                  
                     <button
                         type="button"
                         onClick={this.otherPaid}
                         className="ml-3 inline-flex justify-center rounded-md border border-transparent bg-orange-600 py-1 px-3 text-sm font-medium text-white shadow-sm hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2"
                     >
                         Other Paid
                     </button> */}

                     <button
                         type="button"
                         onClick={this.makeVacant}
                         className="ml-3 inline-flex justify-center rounded-md border border-transparent bg-yellow-600 py-1 px-3 text-sm font-medium text-white shadow-sm hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2"
                     >
                         Make Vacant
                     </button>

                     <button
                         type="button"
                         onClick={this.UnpaidTenants}
                         className="ml-3 inline-flex justify-center rounded-md border border-transparent bg-blue-600 py-1 px-3 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                     >
                         Unpaid Tenants
                     </button>

                     <button
                         type="button"
                         onClick={this.makeOverdue}
                         className="ml-3 inline-flex justify-center rounded-md border border-transparent bg-red-600 py-1 px-3 text-sm font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                     >
                        Make Overdue
                     </button>
                 </div>
                 
                        )}

                        <div className="relative flex mr-2">
                          <div className="flex h-6 items-center">
                            <input
                              checked={this.state.masterChecked}
                              id="check_all_invoice"
                              aria-describedby="check-all-device-description"
                              name="check_all_invoice"
                              type="checkbox"
                              onChange={this.handleMasterChange}
                              className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                            />
                          </div>
                          <div className="ml-3 text-sm leading-6">
                            <label
                              htmlFor="comments"
                              className="font-medium text-gray-900"
                            >
                              Check All Invoices
                            </label>
                          </div>
                        </div>

                        <div className="mt-1 mr-2 ">
                          <input
                            type="Date"
                            value={this.state.fromdate}
                            onChange={this.handleFilter}
                            name="fromdate"
                            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                            placeholder="From Date"
                          />
                        </div>

                        <div className="mt-1 mr-2">
                          <input
                            type="Date"
                            value={this.state.todate}
                            onChange={this.handleFilter}
                            name="todate"
                            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                            placeholder="From Date"
                          />
                        </div>

                        <span className=" mt-1  sm:block lg:ml-3">
                          <span className="isolate inline-flex rounded-md shadow-sm">
                            <button
                              type="button"
                              onClick={this.handleSearchSubmit}
                              className="relative inline-flex items-center rounded-l-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
                            >
                              Search
                            </button>
                            <button
                              type="button"
                              onClick={this.filterReset}
                              className="relative -ml-px inline-flex items-center rounded-r-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
                            >
                              Reset
                            </button>
                          </span>
                        </span>
                      </div>

                      <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
                        <button
                          onClick={this.addinvoice}
                          type="button"
                          className="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                        >
                          Create Due
                        </button>
                      </div>
                    </div>
                    <div className="mt-8 flex flex-col">
                      <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                          <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                            <table
                              className={`min-w-full divide-y divide-gray-300 ${this.state.loader}`}
                            >
                              <thead className="bg-gray-50">
                                <tr>
                                  <th
                                    scope="col"
                                    className="py-3 pl-4 pr-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500 sm:pl-6"
                                  >
                                    CheckBox
                                  </th>
                                  <th
                                    scope="col"
                                    className="py-3 pl-4 pr-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500 sm:pl-6"
                                  >
                                    Date
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500"
                                  >
                                    Due#
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500"
                                  >
                                    House Number
                                  </th>

                                  <th
                                    scope="col"
                                    className="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500"
                                  >
                                    Member Name
                                  </th>

                                  <th
                                    scope="col"
                                    className="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500"
                                  >
                                    Amount
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500"
                                  >
                                    Status
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500"
                                  >
                                    Balance Due
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3 text-center text-xs font-medium uppercase tracking-wide text-gray-500"
                                  >
                                    Action
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="divide-y divide-gray-200 bg-white">
                                {this.state.invoices.map((person, index) => (
                                  <tr key={person.id}>
                                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 text-center">
                                      <input
                                        id={index}
                                        checked={person.checkbox_status}
                                        aria-describedby="check-one-invoice-description"
                                        name={"check_one_invoice" + index}
                                        type="checkbox"
                                        onChange={() =>
                                          this.handleCheckboxChange(
                                            index,
                                            person.id,
                                          )
                                        }
                                        className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                                      />
                                    </td>
                                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                      {person.invoice_date}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                      {person.invoice_number}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                      {person.invoice_house?.house_number}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                      {
                                        person.primary_member
                                          ?.primary_contact_first_name
                                      }{" "}
                                      {
                                        person.primary_member
                                          ?.primary_contact_last_name
                                      }
                                    </td>

                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                      {person.invoice_total}
                                    </td>

                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                      {person.invoice_state?.name}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                      {person.invoice_balance_due}
                                    </td>
                                    <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                      <a
                                        href={"Invoiceview/" + person.id_crypt}
                                        target="_blank"
                                      >
                                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 cursor-pointer">
                                          View
                                        </span>
                                      </a>
                                      
                                      {person.invoice_state?.name !='Paid' ?
                                      <span
                                        onClick={() =>
                                          this.CheckPaymentStatus(person.id_crypt)
                                        }
                                        className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 cursor-pointer"
                                      >
                                        Check Payment Status
                                      </span>
                                      :null}

                                      <span
                                        onClick={() =>
                                          this.delete(person.id_crypt)
                                        }
                                        className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-pink-100 text-pink-800 cursor-pointer"
                                      >
                                        Delete
                                      </span>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                            {/*pagination*/}

                            {/*part_three_pagination_links----------------------------------------------------------------------------------------------*/}
                            <PaginationLinks
                              from={this.state.from}
                              to={this.state.to}
                              total_no_of_item={this.state.total_no_of_project}
                              links={this.state.links}
                              paginationFetch={this.paginationFetch}
                            />
                            {/*part_three_pagination_links----------------------------------------------------------------------------------------------*/}

                            {/*pagination*/}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* /End replace */}
                </div>
              </div>
            </main>
          </div>
          )}
        </div>

        <div
          aria-live="assertive"
          className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
        >
          <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
            {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
            <Transition
              show={this.state.showmsg}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
                <div className="p-1">
                  <div className="flex items-start">
                    <div className="flex-shrink-0">
                      <CheckCircleIcon
                        className="h-6 w-6 text-green-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                      <p className="text-sm font-medium text-gray-900">
                        Successfully Registered!
                      </p>
                      <p className="mt-1 text-sm text-gray-500">
                        You can Login now
                      </p>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex">
                      <button
                        className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={() => {
                          this.setState({ showmsg: false });
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
        {/*DeleteAlert */}
        <Transition.Root show={this.state.deletealartmsg} as={Fragment}>
          <Dialog
            as="div"
            className="fixed z-10 inset-0 overflow-y-auto"
            onClose={() =>
              this.setState({
                deletealartmsg: false,
                deleteMessage: "Are you sure you want to delete the Due ?",
              })
            }
          >
            <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
              </Transition.Child>

              {/* This element is to trick the browser into centering the modal contents. */}
              <span
                className="hidden sm:inline-block sm:align-middle sm:h-screen"
                aria-hidden="true"
              >
                &#8203;
              </span>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <div className="relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                  <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                    <button
                      type="button"
                      className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                      onClick={() =>
                        this.setState({
                          deletealartmsg: false,
                          deleteMessage:
                            "Are you sure you want to delete the Due ?",
                        })
                      }
                    >
                      <span className="sr-only">Close</span>
                      <XIcon className="h-6 w-6" aria-hidden="true" />
                    </button>
                  </div>
                  <div className="sm:flex sm:items-start">
                    <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                      <ExclamationIcon
                        className="h-6 w-6 text-red-600"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                      <Dialog.Title
                        as="h3"
                        className="text-lg leading-6 font-medium text-gray-900"
                      >
                        Delete Due
                      </Dialog.Title>
                      <div className="mt-2">
                        <p className="text-sm text-gray-500">
                          {this.state.deleteMessage}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                    <button
                      type="button"
                      className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                      onClick={this.haldleDelete}
                    >
                      Delete
                    </button>
                    <button
                      type="button"
                      className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
                      onClick={() =>
                        this.setState({
                          deletealartmsg: false,
                          deleteMessage:
                            "Are you sure you want to delete the due ?",
                        })
                      }
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition.Root>
        {/*End DeleteAlert */}
      </>
    );
  }
}

export default InvoiceList;
